module.exports = __webpack_public_path__ + "media/app/images/background-274f5290617999bdf9aa119a09f0bf8e.png";